import { useCallback, useContext, useEffect } from 'react';
import { sessionTimerConfig } from 'config';
import { useIdleTimer } from 'react-idle-timer';
import { UserContext } from 'context/UserContext';
import { useAuth } from 'hooks/useAuth/useAuth';
import { LOGIN_ROUTE } from 'constants/routes';
import { useCustomNavigate } from 'hooks/useCustomNavigate';

/**
 * Extends user session automatically when user is active in the application
 */
export const AutoExtendSession = () => {
    const { extendUserSession } = useAuth();
    const { user, session, setShowExtendSessionDailog } = useContext(UserContext);
    const { navigateWithRedirectTo } = useCustomNavigate();

    const onInactivity = useCallback(() => {
        if (session.active && user) {
            setShowExtendSessionDailog(true);
        } else {
            navigateWithRedirectTo({ pathname: LOGIN_ROUTE });
        }
    }, [session]);

    const idleTimer = useIdleTimer({
        onIdle: onInactivity,
        onAction: extendUserSession,
        timeout: sessionTimerConfig().maxInactiveTime * 1000
    });

    useEffect(() => {
        () => {
            idleTimer.reset();
        };
    }, []);

    return <></>;
};
